import * as iconSet from '@quasar/extras/ionicons-v5'
import Vue from 'vue'

export default function (name: string): { icon: string } | undefined {
  if (name === 'logo-app') {
    return {
      icon: 'svguse:app-logo.svg#icon'
    }
  } else if (!name.startsWith('M') && !name.startsWith('img:')) {
    const iconName = ('ion-' + name).replace(/(-\w)/g, m => m[1].toUpperCase())
    return {
      icon: (iconSet as { [key: string]: string })[iconName]
    }
  }
}

export function svgIcon(name: string) {
  const iconName = ('ion-' + name).replace(/(-\w)/g, m => m[1].toUpperCase())
  const iconData = (iconSet as { [key: string]: string })[iconName]
  const [ def, viewBox ] = iconData.split('|')
  const nodes = def.split('&&').map(path => {
    const [ d, style, transform ] = path.split('@@')
    return `<path d="${d}" transform="${transform || ''}" style="${style || ''}" />`
  })
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox || '0 0 24 24'}">` + nodes.join('') + `</svg>`
}
